import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** Staff only. Starts running the warm's unified home metrics batched and per merchant and returns
 * at once; the summary is logged as "Home metrics unified trial". */
export const runHomeMetricsUnifiedTrial = {
  name: "runHomeMetricsUnifiedTrial" as const,
  input: z.object({
    /** Leave out to run every merchant the warm covers. */
    teamIds: z.array(zExt.objectId()).min(1).optional(),
    /** Statements in flight at once; 4 when left out. */
    concurrency: z.number().int().min(1).max(8).optional(),
  }),
  output: z.object({
    /** False when a run is already going on any server. */
    started: z.boolean(),
  }),
};
